export default __webpack_public_path__ + "static/media/catlow2.dd99db44.jpg";